<template>
  <v-app none class="white">
    <router-view/>
    <v-dialog max-width="450px"
      persistent
      v-model="forceLogin"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <v-icon class="mr-2" color="black">las la-exclamation-circle</v-icon>
          Session Timeout
        </v-card-title>
        <v-card-text>
          Your session has expired due to inactivity. Please click on login button to re-login.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            color="primary"
            class="white--text elevation-0"
            @click.stop="logoutUser()"
          >
            Login again!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
    v-if="updateReportData"
    style="    height: 100vh;
    position: fixed;    margin-left: -20px;"
      :timeout="-1"
      :value="true"
      absolute
      bottom
      outlined
      right
    >
      <div v-if="updateReportData.show">
        Downloading report <v-icon style="float:right;" @click="closeReport()">las la-times</v-icon>
      </div>
      <div v-if="!updateReportData.show">
        Downloaded report <v-icon @click="downloadReport(updateReportData.data)">las la-download</v-icon> <v-icon style="float:right;" @click="closeReport()">las la-times</v-icon>
      </div>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',

  computed: {
    ...mapState({
      snackbar: state => state.snackbar,
      updateReportData: state => state.updateReportData,
      userLogoutSucces: state => state.userLogoutSucces
    })
  },

  data () {
    return {
      forceLogin: false
    };
  },

  watch: {
    userLogoutSucces () {
      this.logoutPopup();
    }
  },

  beforeMount () {
    window.addEventListener('online', this.backOnline);
    window.addEventListener('offline', this.offlineNow);
  },

  beforeDestroy () {
    window.removeEventListener('online', this.backOnline);
    window.removeEventListener('offline', this.offlineNow);
  },

  methods: {
    downloadReport (link) {
      setTimeout(() => {
        window.open(link);
      }, 100);
    },
    closeReport () {
      this.$store.dispatch('updateReportData', null);
    },
    logoutUser () {
      this.$store.dispatch('deleteSession');
      // this.$router.push({ path: '/' }).catch(() => {});
    },
    logoutPopup () {
      if (this.userLogoutSucces === 'logoutSuccessFully') {
        this.forceLogin = true;
        // this.$swal({
        //   title: 'Session Timeout',
        //   text: '',
        //   type: 'warning',
        //   // showCancelButton: true,
        //   confirmButtonColor: '#0d2c8d',
        //   focusConfirm: false,
        //   backdrop: true,
        //   allowOutsideClick: false,
        //   confirmButtonText: '',
        // }).then((result) => {
        //   if (result.value) {
        //     this.$store.dispatch('deleteSession');
        //     // this.$router.push('/');
        //   }
        // });
      }
    },
    start () {
      this.$Progress.start();
    },
    backOnline () {
      // 🦄🎊🔥 we're back online!
      this.$store.dispatch('updateSnackbar', {
      });
      setTimeout(() => {
        this.$store.dispatch('updateSnackbar', {
          color: 'info',
          show: true,
          text: 'You are now connected to internet.'
        });
      }, 400);
    },
    offlineNow () {
      this.$store.dispatch('updateSnackbar', {
        color: 'error',
        show: true,
        text: 'You are not connected to internet. Please check your internet connection.'
      });
    }
  }
};
</script>

<style lang="scss">
@import './assets/css/app.scss';
// hide recaptcha
.grecaptcha-badge {
  display: none !important;
}

.grecaptcha-badge {
  div {
    margin-left: auto;
    margin-right: auto;
    text-align: center !important;
    div {
      margin-left: auto;
      margin-right: auto;
      text-align: center !important;
    }
  }
}

.g-recaptcha div {
  margin-left: auto;
  margin-right: auto;
  text-align: center !important;
  div {
    margin-left: auto;
    margin-right: auto;
    text-align: center !important;
  }
}

// custom classes
.w-100 {
  width: 100%;
}
// override vuetify classes
.v-btn {
  // text-transform: capitalize !important;
  text-transform: initial!important;
}
</style>
